import React from "react";
import ReactDOM from "react-dom";
import "core-js/stable";
import "regenerator-runtime/runtime";
import "@/utils/monaco_workers";

import { App } from "@/components/App";
import { appStore } from "@/app_store";
import { InputProvider } from "@/components/toolkit/InputProvider";
import { defaultBindings } from "@/utils/input_manager/defaultBindings";

// PWA back-button guard.
// Android processes back presses at OS level before JS runs, so a single guard
// entry isn't enough — two rapid presses go base→exit before popstate fires.
// With GUARD_DEPTH entries above the base, N rapid presses land at depth-N,
// which still has canGoBack()=true so the PWA won't close.
// The handler replenishes all guards whenever the base is actually reached.
const PWA_GUARD_DEPTH = 3;
history.replaceState({ pwa_base: true }, "");
for (let i = 0; i < PWA_GUARD_DEPTH; i++) {
    history.pushState({ pwa_guard: true }, "");
}
window.addEventListener("popstate", (e) => {
    if ((e.state as any)?.pwa_base === true) {
        for (let i = 0; i < PWA_GUARD_DEPTH; i++) {
            history.pushState({ pwa_guard: true }, "");
        }
    }
});

document.addEventListener("DOMContentLoaded", function() {
    const element = document.getElementById("application");
    if (element) {
        ReactDOM.render(<InputProvider defaultBindings={defaultBindings}><App /></InputProvider>, element);
    }
});
